import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import Amplify from 'aws-amplify';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import router from './router'

Vue.use(VueRouter)
Vue.use(Vuetify)
applyPolyfills().then(() => {
  defineCustomElements(window);
});
Amplify.configure({
  Auth: {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_AWS_REGION,
    identityPoolRegion: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID,
    oauth: {
      domain: process.env.VUE_APP_USERPOOL_DOMAIN,
      scope: [
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: window.location.origin + "/auth",
      responseType: "code"
    },
  },
  Storage: {
    AWSS3: {
      bucket: process.env.VUE_APP_BUCKET_NAME,
      region: process.env.VUE_APP_AWS_REGION,
      serverSideEncryption: "AES256"
    }
  },
  API: {
    endpoints: [
      {
        name: process.env.VUE_APP_API_NAME,
        region: process.env.VUE_APP_AWS_REGION,
        endpoint: process.env.VUE_APP_ENDPOINT
      }
    ]
  }
});


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

